module.exports = __webpack_public_path__ + "static/img/data_error_img.bbd5784a.png";